import { makeStyles } from '@material-ui/core/styles';

import { blue } from 'shared/styles/colors';

export default makeStyles({
  description: {
    fontWeight: 500,
  },
  details: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    '& > summary': {
      display: 'block',
      '&::-webkit-details-marker': { display: 'none' },
      '& > span': {
        color: blue['60'],
        cursor: 'pointer',
      },
    },
  },
});
